import { Box, Table, TableContainer, Tbody, Text, Th, Thead, Tr, useDisclosure } from '@chakra-ui/react'
import moment from 'moment';
import React, { useEffect, useState } from 'react'
import { GetPendingRequest, GetPendingSCN, GetPendingSRA, ReadRequestHistory } from '../Utils/ApiCalls'
import MorePendingSRA from './MorePendingSra';
import MoreSRA from './MoreSRA';
import PendingIQA from './PendingIQA';
import ScnDetails from './ScnDetails';
import TableRow from './TableRow'
import UpdateQty from './UpdateQty';
import HistoryRequest from './HistoryRequest';

export default function RequestApproval() {

    const [Data, setData] = useState([]);
    const [SraID, setSraID] = useState("");
    const [ModelState, setModelState] = useState(false);
    const [Id, setId] = useState("");
    const [HistoryData, setHistoryData] = useState([]);

    const [HandleMoreSRA, setHandleMoreSRA] = useState(false);
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [OpenModal, setOpenModal] = useState(false);
    const [SingleData, setSingleData] = useState([]);



    const AllPendingRequest = async () => {
        let result = await GetPendingRequest()

        console.log("object pending request", result);

        if (result.status == true) {
            setData(result.queryresult.allrequest)
        }
    }


    const editQty = (id) => {

        let singleInfo = Data.filter((item, i) => {
          return item._id === id
        })
        setOpenModal(true)
        setSingleData(singleInfo)
      }

      const openApprove = (id)=>{
        onOpen()
        setId(id)
      }

      const OpenHistory = async (id) => {

        // alert(id)

        let result = await ReadRequestHistory(id)

        console.log("result history", result);

        if (result.status == true) {
            setHistoryData(result.queryresult.allrequest)
            setModelState(true)


        }
    }


    useEffect(() => {

        AllPendingRequest()

    }, [isOpen, OpenModal]);


    return (
        <Box display={"block"} alignItems="flex-start" w={"100%"} height="70vh" minH={"70vh"} overflow="auto" _hover={{ overflow: "auto" }} bg="blue.blue200" mt="32px" rounded={"8px"}>


            <Text p="10px" textTransform="Capitalize" color="#fff" display={"flex"} justifyContent="flex-end">Total Pending Approval - {Data.length}</Text>

            <TableContainer w={"100%"} mt="32px" overflowX="auto" color="#fff"

            >
                <Table variant='simple' size='sm' overflowX="auto" >
                    <Thead>
                        <Tr>
                            <Th color="#fff">S/N</Th>
                            <Th color="#fff">Ticket No</Th>
                            <Th color="#fff">Staff Email</Th>
                            <Th color="#fff">Staff Department</Th>
                            <Th color="#fff">Product name</Th>
                            <Th color="#fff">Qty Requested</Th>
                            <Th color="#fff">Request Date</Th>
                            <Th color="#fff">History</Th>
                            <Th color="#fff">Approve</Th>
                          

                        </Tr>
                    </Thead>
                    <Tbody>

                        {

                            Data?.map((item, i) => (
                                <TableRow
                                    key={i}
                                    sn={i + 1}
                                    type="RequestApproval"
                                    ticketNo={item.ticket}
                                    email={item.staffemail}
                                    dept={item.department}
                                    productName={item.productname}
                                    qty={item.qtyrequested}
                                    store={item.store}
                                    dateReceived={moment(item.requestdate).format("DD/MM/YYYY")}
                                    Approve={() => openApprove(item._id)}
                                    history={() => OpenHistory(item.staffid)}
                                    onClick={() => editQty(item._id)}

                                   
                                />
                            ))
                        }


                    </Tbody>

                </Table>
            </TableContainer>
            {/* this is for the approval modal that receive the type of approval*/}

            <PendingIQA SingleData={SingleData} isOpen={isOpen} onClose={onClose} id={Id} state="ApproveRequest" />
            <UpdateQty SingleData={SingleData} state="request" isOpen={OpenModal} onClose={()=>setOpenModal(false)} id={Id}/>
            <HistoryRequest isOpen={ModelState} onClose={() => setModelState(false)} singleData={HistoryData} />


        </Box>
    )
}
